import { Clock } from '@common_components/clock/clock.component';
import { APP_KEY } from 'constants/app.constants';
import React, { ReactNode } from 'react';
import Bar from '../bar.component';
import { AppLink } from '@umanforge/common';

interface BottomBarProps {
  children?: ReactNode;
  isLeftNavBar?: boolean;
  hide?: boolean;
}

const BottomBar: React.FC<BottomBarProps> = ( { children, isLeftNavBar = true,  hide = false } ) => {
  return (
    <div className={`px-8 bottom-0 w-full h-[70px] backdrop-blur-sm z-10 ${hide ? 'hidden' : 'fixed'} ${ isLeftNavBar ? 'pl-28' : '' }`}>
      <Bar/>
      <div className='flex justify-between items-center my-1.5'>
        <AppLink appKey={APP_KEY} />

        <div className="mx-4 h-full max-w-[calc(100%-16rem)] flex-wrap">
          {children}
        </div>

        <div className='font-title text-right w-32 flex-center'>
          <Clock />
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
